// External Imports
import { useContext } from "react";
import { MdPeople, MdPerson } from "react-icons/md";
import { DataContext } from "../../context/data-context";

// Internal Imports

/** ========================================================================
 * * DomainSwitch Component
 * This component renders a switch to toggle scope domain.
 * ========================================================================== */

export default function DomainSwitch({ on, onSwitch }) {
  const { admin } = useContext(DataContext);
  
  const bkgClasses = () => {
    let classes =
      "w-10 h-6 cursor-pointer rounded-full transition-all duration-300 flex items-center ";
    if (on) classes += "bg-green-600";
    else classes += "bg-stone-400";
    return classes;
  };

  const btnClasses = () => {
    let classes =
      "w-6 h-6 rounded-full transition-all duration-300 my-auto bg-white flex items-center justify-center ";
    if (on) classes += "translate-x-4";
    else classes += "translate-x-0";
    return classes;
  };

  const switchHandler = () => {
    if (on) onSwitch("All");
    else onSwitch(admin?.id);
  };
  return (
    <div className={bkgClasses()} onClick={switchHandler}>
      <div className={btnClasses()}>
        {on ? (
          <MdPerson className="w-5 h-5 text-green-600" />
        ) : (
          <MdPeople className="w-5 h-5 text-stone-400" />
        )}
      </div>
    </div>
  );
}
